import React, {useEffect, useState} from 'react'
import ErrorInfoComponent from "../../../general/ErrorInfoComponent";
import FetchUtil from "../../../../util/FetchUtil";
import ConfigUtil from "../../../../util/ConfigUtil";

const vorhanden = (wert) => wert !== null && wert !== undefined;

// Spieler mit idShortSinglePlayer1 sind Doppel-Einträge, die werden nicht einzeln ausgewählt
const isAuswaehlbar = (player) => !vorhanden(player.idShortSinglePlayer1);

/**
 * Spiele der Gastmannschaft je Phase, die Spieler werden den Spielen zugewiesen.
 * Logik wie PublicLigaspielttagGamesTab der alten Ansicht.
 */
export default function GasteingabeSpiele({tournamentid, qrcode, counter}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const [geladen, setGeladen] = useState(false);
    const [games, setGames] = useState([]);
    const [players, setPlayers] = useState([]);
    const [selectedBereich, setSelectedBereich] = useState(1);
    const [aktuellerBereich, setAktuellerBereich] = useState(1);
    const [hoechsterBereich, setHoechsterBereich] = useState(1);
    // {gameId, type, titel}, solange die Spielerauswahl offen ist
    const [auswahl, setAuswahl] = useState(undefined);

    useEffect(() => {
        if (!vorhanden(tournamentid)) {
            return;
        }
        ladeGames();
    }, [counter]);

    const ladeGames = () => {
        setErrorMessage(undefined);
        FetchUtil.fetchGet(ConfigUtil.getConfig().resourceUrls.public + "/ligaspieltag/games/" + tournamentid + "/" + qrcode,
            (json) => {
                setGames(json.games);
                setAktuellerBereich(json.aktuellerBereich);
                setPlayers(json.players);
                setSelectedBereich(json.aktuellerBereich);
                setHoechsterBereich(json.hoechsterBereich);
                setGeladen(true);
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
            }
        );
    }

    const savePlayer = (playerId, gameId, type) => {
        setErrorMessage(undefined);
        const data = {playerId: playerId, gameId: gameId, type: type};
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.public + "/ligaspieltag/player/save/" + tournamentid + "/" + qrcode,
            data,
            (json) => {
                setInfoMessage(vorhanden(playerId) ? "Spieler wurde gespeichert." : "Spieler wurde entfernt.");
                setGames(json.games);
                setAktuellerBereich(json.aktuellerBereich);
                setPlayers(json.players);
                setAuswahl(undefined);
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
                setAuswahl(undefined);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
                setAuswahl(undefined);
            }
        );
    }

    const getPlayerName = (playerId) => {
        if (!vorhanden(playerId)) {
            return undefined;
        }
        const player = players.find(p => p.id === playerId);
        return player ? player.name : undefined;
    }

    /**
     * Eine Position im Spiel (Einzel bzw. einer der beiden Doppelpartner).
     */
    const getPosition = (game, playerId, type, label) => {
        const name = getPlayerName(playerId);
        return <div className="dhpt-gast-position">
            {label && <span className="dhpt-gast-position-label">{label}</span>}
            <span className={name ? "dhpt-gast-name" : "dhpt-gast-name dhpt-gast-name-leer"}>{name || "Noch kein Spieler"}</span>
            {!game.gesperrt && <span className="dhpt-gast-aktionen">
                <button type="button" className="dhpt-gast-knopf" aria-label={name ? "Spieler ändern" : "Spieler wählen"}
                        onClick={() => setAuswahl({gameId: game.id, type: type, titel: "Spiel " + game.counter + (label ? " · " + label : "")})}>
                    <i className="pi pi-pencil" aria-hidden="true"/>
                    <span className="dhpt-gast-knopf-text">{name ? "Ändern" : "Wählen"}</span>
                </button>
                {vorhanden(playerId) &&
                    <button type="button" className="dhpt-gast-knopf" aria-label="Spieler entfernen" title="Spieler entfernen"
                            onClick={() => savePlayer(undefined, game.id, type)}>
                        <i className="pi pi-trash" aria-hidden="true"/>
                    </button>
                }
            </span>}
        </div>
    }

    const getGameKarte = (game) => {
        if (game.type === "TG") {
            return <div key={game.id} className="dhpt-karte dhpt-gast-spiel">
                <div className="dhpt-gast-spiel-kopf"><span className="dhpt-fett">Spiel {game.counter}</span><span className="dhpt-chip">Team-Game</span></div>
                <p className="dhpt-hinweis">Hier ist nichts für dich zu tun.</p>
            </div>
        }
        if (game.type !== "EZ" && game.type !== "DP") {
            return <div key={game.id} className="dhpt-karte dhpt-gast-spiel">
                Fehlerhafter Gametype, bitte Admin verständigen. LeagueGameId: {game.id}
            </div>
        }
        return <div key={game.id} className="dhpt-karte dhpt-gast-spiel">
            <div className="dhpt-gast-spiel-kopf">
                <span className="dhpt-fett">Spiel {game.counter}</span>
                <span className="dhpt-chip">{game.type === "EZ" ? "Einzel" : "Doppel"}</span>
                {game.gesperrt && <span className="dhpt-gast-gesperrt"><i className="pi pi-lock" aria-hidden="true"/>gesperrt</span>}
            </div>
            {game.type === "EZ"
                ? getPosition(game, game.player2Id, "einzel")
                : <>
                    {getPosition(game, game.doppelpartner2Player1Id, "doppel1", "Spieler 1")}
                    {getPosition(game, game.doppelpartner2Player2Id, "doppel2", "Spieler 2")}
                </>
            }
        </div>
    }

    const getPhasenAuswahl = () => {
        if (games.length === 0) {
            return null;
        }
        const phasen = [];
        for (let bereich = 1; bereich <= hoechsterBereich; bereich++) {
            phasen.push(bereich);
        }
        return <div className="dhpt-gast-phasen">
            <span className="dhpt-gast-phasen-label">Phase</span>
            <div className="dhpt-subs" role="group" aria-label="Phase">
                {phasen.map(bereich => <button key={bereich} type="button" className="dhpt-sub-button" aria-pressed={bereich === selectedBereich}
                                               title={bereich === aktuellerBereich ? "Aktuelle Phase" : undefined}
                                               onClick={() => setSelectedBereich(bereich)}>
                    {bereich === aktuellerBereich && <i className="dhpt-punkt dhpt-gast-punkt-aktuell" aria-hidden="true"/>}
                    {bereich}
                </button>)}
            </div>
            <span className="dhpt-gast-legende"><i className="dhpt-punkt dhpt-gast-punkt-aktuell" aria-hidden="true"/>aktuelle Phase</span>
        </div>
    }

    const getSpielerAuswahl = () => {
        const auswaehlbar = players.filter(isAuswaehlbar);
        return <div className="dhpt-gast-ebene" role="dialog" aria-modal="true" aria-label="Spieler wählen">
            <div className="dhpt-gast-ebene-fenster">
                <div className="dhpt-gast-ebene-kopf">
                    <div>
                        <div className="dhpt-fett">Spieler wählen</div>
                        <div className="dhpt-gast-ebene-zusatz">{auswahl.titel}</div>
                    </div>
                    <button type="button" className="dhpt-gast-knopf" aria-label="Schließen" onClick={() => setAuswahl(undefined)}>
                        <i className="pi pi-times" aria-hidden="true"/>
                    </button>
                </div>
                {auswaehlbar.length === 0
                    ? <p className="dhpt-hinweis">Es sind noch keine Spieler angelegt. Lege sie unter „Mannschaft“ an.</p>
                    : <div className="dhpt-gast-spielerliste">
                        {auswaehlbar.map(player => <button key={player.id} type="button" className="dhpt-gast-spieler"
                                                           onClick={() => savePlayer(player.id, auswahl.gameId, auswahl.type)}>
                            {player.name}
                        </button>)}
                    </div>
                }
            </div>
        </div>
    }

    const gamesImBereich = games.filter(game => game.bereich === selectedBereich);

    return <div>
        <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage}
                            onClearInfoMessage={() => setInfoMessage(undefined)}
                            onClearErrorMessage={() => setErrorMessage(undefined)}/>
        {!geladen
            ? <p className="dhpt-hinweis">Spiele werden geladen …</p>
            : <>
                {getPhasenAuswahl()}
                {gamesImBereich.length === 0
                    ? <p className="dhpt-hinweis">Keine Spiele vorhanden. Evtl. keine Phase gewählt oder der Spieltag ist noch nicht gestartet.</p>
                    : <div className="dhpt-gast-spiele">{gamesImBereich.map(game => getGameKarte(game))}</div>
                }
            </>
        }
        {auswahl !== undefined && getSpielerAuswahl()}
    </div>
}
